import useEnv from "./useEnv";
import useTenant from "./useTenant";

export const useEnvironmentFlag = (flag: string) => {
  const { selectedEnv } = useEnv();

  if (!selectedEnv) {
    return false;
  }

  let decision = selectedEnv.flag_decisions[flag];
  if (decision === undefined || decision === null) {
    console.error(`Flag ${flag} does not exist`);
    decision = false;
  }

  return decision;
};

export const useTenantFlag = (flag: string) => {
  const { tenant } = useTenant();

  if (!tenant) {
    return false;
  }

  let decision = tenant.flag_decisions[flag];
  if (decision === undefined || decision === null) {
    console.error(`Flag ${flag} does not exist`);
    decision = false;
  }

  return decision;
};
